import { motion } from "framer-motion";
import { ONBOARDING_STEPS } from "@/config";
import { SectionHeading } from "@/components/Section";
import { PortalButton } from "@/components/PortalButton";
import { Reveal } from "@/components/Reveal";

export default function Onboarding() {
  return (
    <section data-testid="onboarding-steps" className="py-24 md:py-32 bg-forest text-cream relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] noise-bg" />
      <div className="relative max-w-[1440px] mx-auto px-5 md:px-10">
        <SectionHeading
          dark
          align="center"
          chapter="07 / Onboarding"
          overline="Seamless Customer Onboarding"
          title={<>Start ordering in three simple steps</>}
          lead="Quick registration. Flexible delivery. No complicated onboarding."
          className="mb-16"
        />

        <div className="grid md:grid-cols-3 gap-6 relative">
          {ONBOARDING_STEPS.map((s, i) => (
            <Reveal key={s.no} delay={i * 0.12}>
              <motion.div whileHover={{ y: -6 }} className="h-full rounded-3xl bg-forest-deep border border-white/10 p-8 relative overflow-hidden">
                <span className="font-display text-[5rem] leading-none text-butter-deep/25 absolute top-2 right-4 select-none">{s.no}</span>
                <span className="overline text-butter-deep">Step {s.no}</span>
                <h3 className="font-display text-2xl text-cream mt-4 relative">{s.title}</h3>
                <p className="text-cream/70 text-sm mt-3 leading-relaxed relative">{s.desc}</p>
              </motion.div>
            </Reveal>
          ))}
        </div>

        <Reveal className="flex justify-center mt-12">
          <PortalButton variant="butter" testId="create-account-onboarding-btn">Create My Wholesale Account</PortalButton>
        </Reveal>
      </div>
    </section>
  );
}
